import React, { Component } from 'react'
import { connect } from 'react-redux';
import CatalogQuickCartForm from './catalog-quick-cart-form';

class CatalogQuickCart extends Component {

  // constructor(props) {
  //   super(props);
  // }

  render() {
    const { showQuickCart, isMobile } = this.props;

      return (
        <div className={(showQuickCart) ? 'cart-drawer quick-cart open' : 'cart-drawer quick-cart'}>
          <CatalogQuickCartForm isMobile={isMobile} />
        </div>
      );
  }
}

const mapStateToProps = ({ catalog }) => {
  const { showQuickCart } = catalog;

  return { showQuickCart };
};

export default connect(mapStateToProps)(CatalogQuickCart);
